export default __webpack_public_path__ + "0438d12ad6eef8b121694267e449d230.png";